define('modules/private/model',['require','exports','module','app','env','helpers/CommonHelper'],function (require, exports, module) {
  "use strict";
  var app = require("app");
  var Config = require("env");
  var CommonHelper = require("helpers/CommonHelper");

  var Model = Backbone.Model.extend({
    url: function () {
      return Config.backendUrl + "/auth/me";
    },

    getRole: function () {
      return this.get("ROL_ID") ? this.get("ROL_ID")[0] : null;
    },

    getGroup: function () {
      return this.get("GROUP_ID") ? this.get("GROUP_ID")[0] : null;
    },

    getEmail: function () {
      return this.get("EMAIL")[0];
    },

    getUID: function () {
      return this.get("UID") ? this.get("UID")[0] : null;
    },

    isAdmin: function () {
      if (!this.get("ROL_ID")) {
        return false;
      }

      return (
        this.get("ROL_ID")[0] === CommonHelper.ROL_ADM_MDIRECTOR ||
        this.isSuperAdmim()
      );
    },

    isAdminFreemium: function () {
      if (!this.get("ROL_ID")) {
        return false;
      }

      return this.get("ROL_ID")[0] === CommonHelper.ROL_ADM_MDIRECTOR_NEWFREE;
    },

    isAdm: function () {
      return this.isAdmin() || this.isAdminFreemium();
    },

    isSuperAdmim: function () {
      if (!this.get("ROL_ID")) {
        return false;
      }

      return this.get("ROL_ID")[0] === CommonHelper.ROL_SUPER_ADM_MDIRECTOR;
    },

    getName: function () {
      return this.get("NAME") + " " + this.get("LASTNAME");
    },
    checkApiIsEnabled: function () {
      return this.get("apiAccessEnabled");
    },

    getGroupCompanies: function () {
      return this.get("groupCompanies") || [];
    },

    getCompanyId: function () {
      return Config.companyId;
    },
    isEmBlue: function () {
      return this.get("isEmBlue");
    },
  });

  module.exports = Model;
});

